import styled from 'styled-components';
import FormWithProvider from 'components/forms/form/Form';
import theme from 'styles/theme';
import {
  PrimaryCtaButton,
  TEXT_NEUTRAL,
  TEXT_PRIMARY,
} from '../HostfullyAssist.styles';

export const Page = styled.div.attrs({ className: 'container' })`
  color: ${TEXT_PRIMARY};
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding-bottom: 48px;
  padding-top: 24px;
`;

export const TableScroller = styled.div`
  max-width: 100%;
  overflow-x: auto;
`;

export const PricingTable = styled.table`
  border-collapse: collapse;
  min-width: 480px;
  width: 100%;

  caption {
    caption-side: top;
    color: ${TEXT_PRIMARY};
    font-size: 1.71rem;
    font-weight: 700;
    text-align: left;
  }

  td {
    border-top: 1px solid ${theme.colors.gray300};
    font-size: 16px;
    padding: 16px 0;
    vertical-align: top;
  }

  tr:first-child td {
    border-top: 1px solid ${TEXT_NEUTRAL};
  }

  tr:last-child td {
    border-bottom: 1px solid ${theme.colors.gray300};
  }

  td:last-child {
    text-align: right;
  }
`;

export const IncludedTable = styled(PricingTable)`
  min-width: 560px;

  td,
  td:last-child {
    font-weight: 400;
    text-align: left;
    width: 50%;
  }
`;

export const IncludedItem = styled.span`
  align-items: center;
  display: flex;
  gap: 12px;

  svg {
    fill: #000;
    flex-shrink: 0;
    height: 16px;
    width: 16px;
  }
`;

export const SubCaption = styled.p`
  font-size: 1.14rem;
  font-weight: normal;
  margin: 0;
  padding-top: 10px;
`;

export const TrialLabel = styled.span`
  display: block;
  font-weight: 400;
`;

export const PropertiesValue = styled.span`
  align-items: center;
  display: inline-flex;
  gap: 8px;
  justify-content: flex-end;
`;

export const Agreements = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 8px;

  .checkbox {
    margin: 0;
  }
`;

export const TryForFreeButton = styled(PrimaryCtaButton)`
  align-self: flex-start;
  margin-top: 24px;
`;

export const Footnote = styled.p`
  color: ${theme.colors.gray600};
  font-size: 14px;
  margin: 0;
  padding-top: 24px;
`;

export const FormStyled = styled(FormWithProvider)`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;
